import React from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageToggle } from './LanguageToggle';

interface LoginProps {
  onLogin: (employeeNumber: string, password: string) => Promise<void>;
  error?: string;
}

export function Login({ onLogin, error }: LoginProps) {
  const { t } = useTranslation();
  const [employeeNumber, setEmployeeNumber] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await onLogin(employeeNumber.trim(), password.trim());
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-slate-100 to-blue-50 p-6">
      <form onSubmit={handleSubmit} className="w-full max-w-sm bg-white shadow-lg rounded-lg p-8 space-y-6">
        <div className="flex flex-col items-center space-y-3">
          <img 
            src="https://1pwrafrica.com/wp-content/uploads/2018/11/logo.png" 
            alt="1PWR Africa" 
            className="h-16 object-contain"
          />
          <h1 className="text-xl font-bold text-gray-800">uGridPlan – {t('auth.signIn')}</h1>
          <LanguageToggle />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">{t('auth.employeeNumber')}</label>
          <input
            type="text"
            value={employeeNumber}
            onChange={(e) => setEmployeeNumber(e.target.value)}
            className="mt-1 w-full border rounded px-3 py-2 text-sm"
            placeholder={t('auth.employeePlaceholder')}
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">{t('auth.password')}</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-1 w-full border rounded px-3 py-2 text-sm"
            placeholder={t('auth.passwordPlaceholder')}
            maxLength={4}
            pattern="\d{4}"
            required
          />
        </div>
        {error && (
          <div className="text-sm text-red-700 bg-red-100 border border-red-200 rounded px-3 py-2">{error}</div>
        )}
        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white font-semibold rounded px-3 py-2"
        >
          {isSubmitting ? t('auth.signingIn') : t('auth.signIn')}
        </button>
      </form>
    </div>
  );
}
